module.exports = __webpack_public_path__ + "static/media/ImgExcel.d35c2aa4.svg";